import React from 'react'
import { LayoutCP } from 'submodules/nerit-framework-ui/common/components/screen/layout/layout/LayoutCP'
import { HeaderCP } from 'submodules/nerit-framework-ui/common/components/screen/layout/header/HeaderCP'
import { TabsCP } from 'submodules/nerit-framework-ui/common/components/tabs/TabsCP'
import { TabMatrixCP } from 'modules/collection-performance/screens/screen-collection-performance-admin/inner/TabMatrixCP'
import { TabParameterGroupCP } from 'modules/collection-performance/screens/screen-collection-performance-admin/inner/TabParameterGroupCP'

/**
 * Tela 3.1 - Painel Administrativo do Desempenho de Coleta.
 * Cadastro estrutural de Matrizes (agrupamentos de pontos) e Grupos de Parametros.
 * A escrita exige ROLE_ADMIN (as acoes de escrita ficam sob AccessControlCP).
 */
export function ScreenCollectionPerformanceAdmin(): JSX.Element {

    return (
        <LayoutCP
            header={<HeaderCP title={'Desempenho de Coleta — Painel Administrativo'}/>}
            overflowVertical={true}
            content={
                <TabsCP
                    margin={{ top: 10, right: 20, bottom: 10, left: 20 }}
                    defaultActiveKey={'matrix'}
                    tabs={[
                        {
                            key: 'matrix',
                            title: 'Matrizes',
                            content: <TabMatrixCP/>,
                        },
                        {
                            key: 'parameter-group',
                            title: 'Grupos de Parâmetros',
                            content: <TabParameterGroupCP/>,
                        },
                    ]}
                />
            }
        />
    )
}
